<template>
    
                <div class="news-items mt54">
                    
                    <a href="https://mp.weixin.qq.com/s/5aggcpOThYfQZ9SfVUJVJA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727680350681686.jpg" alt="澳门青年企业家冯文滔于新时代穗商培养工程二期顺利结业" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/28<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门青年企业家冯文滔于新时代穗商培养工程二期顺利结业</div>
                                <div class="desc">9月28日，新时代穗商培养工程二期结业暨三期开班活动在广州顺利举行，来自政企各界的代表以及新时代穗商培养工程二期、三期的学员共约500人参加。澳门融贯投资科技有限公司董事长、广州神农智联农业科技发展有限公司联合创始人冯文滔先生作为澳门青年企业家代表参加本次培养工程二期并顺利结业。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/AOWqhZ2lyHtSOWqWd7fQMw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727680048235604.jpg" alt="澳门融贯受邀参加：2024 星火全连接活动（国际化）" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/27<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门融贯受邀参加：2024 星火全连接活动（国际化）</div>
                                <div class="desc">9月27日，2024 星火全连接活动（国际化）专场于中国信通院成功举办，澳门融贯投资科技有限公司总经理陈祥受邀出席并参与 ASTRON 产品质量认证体系“优品码”方阵启动仪式环节。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/uMIqRnbFLGYuoO8eDeLdSQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727679966320164.jpg" alt="鲁澳合作再谱新篇｜鲁澳数字认证服务中心项目签约" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/26<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">鲁澳合作再谱新篇｜鲁澳数字认证服务中心项目签约</div>
                                <div class="desc">9月26日，澳门融贯投资科技有限公司与威海临港经济技术开发区管理委员会于威海成功签约，共同推进鲁澳数字认证服务中心建设及投资运营工作，澳门融贯投资科技有限公司总经理陈祥与威海临港区管委会副主任丛涛代表签约。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/5FTAb6RFcn4Ct4jVNI95hQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727680290864562.jpg" alt="澳门质量品牌国际认证联盟与全国农业展览馆合作推进国家地理标志农产品展示体验馆运营工作" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/19<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门质量品牌国际认证联盟与全国农业展览馆合作推进国家地理标志农产品展示体验馆运营工作</div>
                                <div class="desc">9月19日，澳门质量品牌国际认证联盟与全国农业展览馆举行签约活动，共同推进国家地理标志农产品展示体验馆运营工作。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/1nXL5c_GGEoPCs281dT7nQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727679673889281.png" alt="Mart创新非遗 艺术数拥认证" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">08/25<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">Mart创新非遗 艺术数拥认证</div>
                                <div class="desc">8月23日-25日，由澳门质量品牌国际认证联盟及融贯国际联合呈现“2024Mart澳门`认证技术`艺术科技跨界共融”于澳门威尼斯金光展馆展出。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/x1HxaoLbw5vf-eRjBYNCMQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727679548269283.jpg" alt="景德镇国家陶瓷版权交易中心与澳门贤滔投资有限公司、上海垤和数字科技有限公司合作座谈暨签约仪式成功举行" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/28<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">景德镇国家陶瓷版权交易中心与澳门贤滔投资有限公司、上海垤和数字科技有限公司合作座谈暨签约仪式成功举行</div>
                                <div class="desc">7月28日上午，景德镇国家陶瓷版权交易中心与澳门贤滔投资有限公司、上海垤和数字科技有限公司在景德镇市昌南里“大碗”举办战略合作座谈暨签约仪式。澳门融贯投资科技有限公司总经理陈祥代表签约。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/dOV2iEvlP-Y2frR8PAl0nQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727679394935460.jpg" alt="澳门工商联携同澳门质量品牌国际认证联盟拜访葡萄牙经济部" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/13<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门工商联携同澳门质量品牌国际认证联盟拜访葡萄牙经济部</div>
                                <div class="desc">为进一步深化中葡商贸往来合作，发挥澳门葡语国家“超级联系人”独特作用，近日，澳门工商联携同澳门质量品牌国际认证联盟成员赴葡拜访葡萄牙经济部，双方重点就推进中葡贸易平台基础设施建设、加强双边商品及服务贸易、更好发挥中葡数贸合作机制等议题进行深入交流。葡萄牙经济部国务秘书长约翰瑞·费雷拉（Joào RuiFerreira）对本次澳门参访团一行到访表示欢迎并参加会见。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/cmNmFFOM0d4l5kjmCSzLEQ" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1727678158739044.jpg" alt="澳门质量品牌国际认证联盟与保定市商务局签署战略合作框架协议" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/12<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">澳门质量品牌国际认证联盟与保定市商务局签署战略合作框架协议</div>
                                <div class="desc">7月11日上午，以“新丝路、新动能、新未来”为主题的2024亚洲电子商务生态大会在河北保定开幕，澳门质量品牌国际认证联盟与保定市商务局签订战略合作框架协议书，融贯国际总经理、澳门质量品牌国际认证联盟秘书长陈祥代表签署协议。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>